export default __webpack_public_path__ + "static/media/adyen.ab5cd271.svg";